export const postWatchServiceBaseUrl =
  "https://api.dev.postwatch.warnerbros.com";
export const postWatchSharedServiceBaseUrl = "";
export const OKTA_CLIENT_ID = "0oa1b8v77a45yDY0Q0h8";
export const OKTA_ISSUER_URL = "https://ssobizqa.wbd.com/oauth2/default";
export const OKTA_REDIRECT_URL = window.location.origin + "/callback";
export const OKTA_URL = "https://ssobizqa.wbd.com";
export const IDLE_TIMEOUT = "60";
export const IDLE_WARN_TIMEOUT = "30";